import _slicedToArray from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { connectAudioParam } from '../helpers/connect-audio-param';
import { copyFromChannel } from '../helpers/copy-from-channel';
import { copyToChannel } from '../helpers/copy-to-channel';
import { createNestedArrays } from '../helpers/create-nested-arrays';
import { getAudioNodeConnections } from '../helpers/get-audio-node-connections';
import { getAudioWorkletProcessor } from '../helpers/get-audio-worklet-processor';
import { getNativeAudioNode } from '../helpers/get-native-audio-node';
import { isOwnedByContext } from '../helpers/is-owned-by-context';
import { renderAutomation } from '../helpers/render-automation';
import { renderInputsOfAudioNode } from '../helpers/render-inputs-of-audio-node';

var processBuffer =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(proxy, renderedBuffer, nativeOfflineAudioContext, options, processorDefinition) {
    var length, numberOfInputChannels, numberOfOutputChannels, processedBuffer, audioNodeConnections, audioWorkletProcessor, inputs, outputs, parameters, _loop, i, _ret;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            length = renderedBuffer.length;
            numberOfInputChannels = options.channelCount * options.numberOfInputs;
            numberOfOutputChannels = options.outputChannelCount.reduce(function (sum, value) {
              return sum + value;
            }, 0);
            processedBuffer = numberOfOutputChannels === 0 ? null : nativeOfflineAudioContext.createBuffer(numberOfOutputChannels, length, renderedBuffer.sampleRate);

            if (!(processorDefinition === undefined)) {
              _context.next = 6;
              break;
            }

            throw new Error();

          case 6:
            audioNodeConnections = getAudioNodeConnections(proxy);
            _context.next = 9;
            return getAudioWorkletProcessor(nativeOfflineAudioContext, proxy);

          case 9:
            audioWorkletProcessor = _context.sent;
            inputs = createNestedArrays(options.numberOfInputs, options.channelCount);
            outputs = createNestedArrays(options.numberOfOutputs, options.outputChannelCount);
            parameters = Array.from(proxy.parameters.keys()).reduce(function (prmtrs, name) {
              return _objectSpread({}, prmtrs, _defineProperty({}, name, new Float32Array(128)));
            }, {});

            _loop = function _loop(i) {
              for (var j = 0; j < options.numberOfInputs; j += 1) {
                for (var k = 0; k < options.channelCount; k += 1) {
                  copyFromChannel(renderedBuffer, inputs[j], k, k, i);
                }
              }

              if (processorDefinition.parameterDescriptors !== undefined) {
                processorDefinition.parameterDescriptors.forEach(function (_ref2, index) {
                  var name = _ref2.name;
                  copyFromChannel(renderedBuffer, parameters, name, numberOfInputChannels + index, i);
                });
              }

              for (var _j = 0; _j < options.numberOfInputs; _j += 1) {
                for (var _k = 0; _k < options.outputChannelCount[_j]; _k += 1) {
                  // The byteLength will be 0 when the ArrayBuffer was transferred.
                  if (outputs[_j][_k].byteLength === 0) {
                    outputs[_j][_k] = new Float32Array(128);
                  }
                }
              }

              try {
                var potentiallyEmptyInputs = inputs.map(function (input, index) {
                  if (audioNodeConnections.activeInputs[index].size === 0) {
                    return [new Float32Array(0)];
                  }

                  return input;
                });
                var activeSourceFlag = audioWorkletProcessor.process(potentiallyEmptyInputs, outputs, parameters);

                if (processedBuffer !== null) {
                  for (var _j2 = 0, outputChannelSplitterNodeOutput = 0; _j2 < options.numberOfOutputs; _j2 += 1) {
                    for (var _k2 = 0; _k2 < options.outputChannelCount[_j2]; _k2 += 1) {
                      copyToChannel(processedBuffer, outputs[_j2], _k2, outputChannelSplitterNodeOutput + _k2, i);
                    }

                    outputChannelSplitterNodeOutput += options.outputChannelCount[_j2];
                  }
                }

                if (!activeSourceFlag) {
                  return "break";
                }
              } catch (_a) {
                proxy.dispatchEvent(new ErrorEvent('processorerror'));
                return "break";
              }
            };

            i = 0;

          case 15:
            if (!(i < length)) {
              _context.next = 22;
              break;
            }

            _ret = _loop(i);

            if (!(_ret === "break")) {
              _context.next = 19;
              break;
            }

            return _context.abrupt("break", 22);

          case 19:
            i += 128;
            _context.next = 15;
            break;

          case 22:
            return _context.abrupt("return", processedBuffer);

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function processBuffer(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();

export var createAudioWorkletNodeRendererFactory = function createAudioWorkletNodeRendererFactory(connectMultipleOutputs, createNativeAudioBufferSourceNode, createNativeChannelMergerNode, createNativeChannelSplitterNode, createNativeConstantSourceNode, createNativeGainNode, disconnectMultipleOutputs, nativeAudioWorkletNodeConstructor, nativeOfflineAudioContextConstructor, renderNativeOfflineAudioContext) {
  return function (name, options, processorDefinition) {
    var nativeAudioNodePromise = null;

    var createNativeAudioNode =
    /*#__PURE__*/
    function () {
      var _ref3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(proxy, nativeOfflineAudioContext) {
        var nativeAudioNode, _numberOfInputChannels, numberOfParameters, partialOfflineAudioContext, gainNodes, inputChannelSplitterNodes, i, constantSourceNodes, inputChannelMergerNode, _i, j, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref8, _ref6, index, constantSourceNode, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _ref11, _ref10, nm, audioParam, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _ref14, _ref13, _nm, _audioParam;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                nativeAudioNode = getNativeAudioNode(proxy); // Bug #61: Only Chrome & Opera have an implementation of the AudioWorkletNode yet.

                if (!(nativeAudioWorkletNodeConstructor === null)) {
                  _context4.next = 38;
                  break;
                }

                if (!(processorDefinition === undefined)) {
                  _context4.next = 4;
                  break;
                }

                throw new Error('Missing the processor definition.');

              case 4:
                if (!(nativeOfflineAudioContextConstructor === null)) {
                  _context4.next = 6;
                  break;
                }

                throw new Error('Missing the native (Offline)AudioContext constructor.');

              case 6:
                // Bug #47: The AudioDestinationNode in Edge and Safari gets not initialized correctly.
                _numberOfInputChannels = proxy.channelCount * proxy.numberOfInputs;
                numberOfParameters = processorDefinition.parameterDescriptors === undefined ? 0 : processorDefinition.parameterDescriptors.length;
                partialOfflineAudioContext = new nativeOfflineAudioContextConstructor(_numberOfInputChannels + numberOfParameters, // Ceil the length to the next full render quantum.
                // Bug #17: Safari does not yet expose the length.
                Math.ceil(proxy.context.length / 128) * 128, nativeOfflineAudioContext.sampleRate);
                gainNodes = [];
                inputChannelSplitterNodes = [];

                for (i = 0; i < options.numberOfInputs; i += 1) {
                  gainNodes.push(createNativeGainNode(partialOfflineAudioContext, {
                    channelCount: options.channelCount,
                    channelCountMode: options.channelCountMode,
                    channelInterpretation: options.channelInterpretation,
                    gain: 1
                  }));
                  inputChannelSplitterNodes.push(createNativeChannelSplitterNode(partialOfflineAudioContext, {
                    channelCount: options.channelCount,
                    channelCountMode: 'explicit',
                    channelInterpretation: 'discrete',
                    numberOfOutputs: options.channelCount
                  }));
                }

                _context4.next = 14;
                return Promise.all(Array.from(proxy.parameters.values()).map(
                /*#__PURE__*/
                function () {
                  var _ref4 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee2(audioParam) {
                    var constantSourceNode;
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            constantSourceNode = createNativeConstantSourceNode(partialOfflineAudioContext, {
                              channelCount: 1,
                              channelCountMode: 'explicit',
                              channelInterpretation: 'discrete',
                              offset: audioParam.value
                            });
                            _context2.next = 3;
                            return renderAutomation(proxy.context, partialOfflineAudioContext, audioParam, constantSourceNode.offset);

                          case 3:
                            return _context2.abrupt("return", constantSourceNode);

                          case 4:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x8) {
                    return _ref4.apply(this, arguments);
                  };
                }()));

              case 14:
                constantSourceNodes = _context4.sent;
                inputChannelMergerNode = createNativeChannelMergerNode(partialOfflineAudioContext, {
                  channelCount: 1,
                  channelCountMode: 'explicit',
                  channelInterpretation: 'speakers',
                  numberOfInputs: Math.max(1, _numberOfInputChannels + numberOfParameters)
                });

                for (_i = 0; _i < options.numberOfInputs; _i += 1) {
                  gainNodes[_i].connect(inputChannelSplitterNodes[_i]);

                  for (j = 0; j < options.channelCount; j += 1) {
                    inputChannelSplitterNodes[_i].connect(inputChannelMergerNode, j, _i * options.channelCount + j);
                  }
                }

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context4.prev = 20;

                for (_iterator = constantSourceNodes.entries()[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  _ref8 = _step.value;
                  _ref6 = _slicedToArray(_ref8, 2);
                  index = _ref6[0];
                  constantSourceNode = _ref6[1];
                  constantSourceNode.connect(inputChannelMergerNode, 0, _numberOfInputChannels + index);
                  constantSourceNode.start(0);
                }

                _context4.next = 28;
                break;

              case 24:
                _context4.prev = 24;
                _context4.t0 = _context4["catch"](20);
                _didIteratorError = true;
                _iteratorError = _context4.t0;

              case 28:
                _context4.prev = 28;
                _context4.prev = 29;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 31:
                _context4.prev = 31;

                if (!_didIteratorError) {
                  _context4.next = 34;
                  break;
                }

                throw _iteratorError;

              case 34:
                return _context4.finish(31);

              case 35:
                return _context4.finish(28);

              case 36:
                inputChannelMergerNode.connect(partialOfflineAudioContext.destination);
                return _context4.abrupt("return", Promise.all(gainNodes.map(function (gainNode) {
                  return renderInputsOfAudioNode(proxy, partialOfflineAudioContext, gainNode);
                })).then(function () {
                  return renderNativeOfflineAudioContext(partialOfflineAudioContext);
                }).then(
                /*#__PURE__*/
                function () {
                  var _ref7 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee3(renderedBuffer) {
                    var audioBufferSourceNode, numberOfOutputChannels, outputChannelSplitterNode, outputChannelMergerNodes, _i2, processedBuffer, _i3, outputChannelSplitterNodeOutput, outputChannelMergerNode, _j3, outputAudioNodes;

                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            audioBufferSourceNode = createNativeAudioBufferSourceNode(nativeOfflineAudioContext);
                            numberOfOutputChannels = options.outputChannelCount.reduce(function (sum, value) {
                              return sum + value;
                            }, 0);
                            outputChannelSplitterNode = createNativeChannelSplitterNode(nativeOfflineAudioContext, {
                              channelCount: Math.max(1, numberOfOutputChannels),
                              channelCountMode: 'explicit',
                              channelInterpretation: 'discrete',
                              numberOfOutputs: Math.max(1, numberOfOutputChannels)
                            });
                            outputChannelMergerNodes = [];

                            for (_i2 = 0; _i2 < proxy.numberOfOutputs; _i2 += 1) {
                              outputChannelMergerNodes.push(createNativeChannelMergerNode(nativeOfflineAudioContext, {
                                channelCount: 1,
                                channelCountMode: 'explicit',
                                channelInterpretation: 'speakers',
                                numberOfInputs: options.outputChannelCount[_i2]
                              }));
                            }

                            _context3.next = 7;
                            return processBuffer(proxy, renderedBuffer, nativeOfflineAudioContext, options, processorDefinition);

                          case 7:
                            processedBuffer = _context3.sent;

                            if (processedBuffer !== null) {
                              audioBufferSourceNode.buffer = processedBuffer;
                              audioBufferSourceNode.start(0);
                            }

                            audioBufferSourceNode.connect(outputChannelSplitterNode);

                            for (_i3 = 0, outputChannelSplitterNodeOutput = 0; _i3 < proxy.numberOfOutputs; _i3 += 1) {
                              outputChannelMergerNode = outputChannelMergerNodes[_i3];

                              for (_j3 = 0; _j3 < options.outputChannelCount[_i3]; _j3 += 1) {
                                outputChannelSplitterNode.connect(outputChannelMergerNode, outputChannelSplitterNodeOutput + _j3, _j3);
                              }

                              outputChannelSplitterNodeOutput += options.outputChannelCount[_i3];
                            } // Bug #87: Expose at least one output to make this node connectable.


                            outputAudioNodes = options.numberOfOutputs === 0 ? [outputChannelSplitterNode] : outputChannelMergerNodes;
                            audioBufferSourceNode.connect = connectMultipleOutputs.bind(null, outputAudioNodes);
                            audioBufferSourceNode.disconnect = disconnectMultipleOutputs.bind(null, outputAudioNodes);
                            return _context3.abrupt("return", audioBufferSourceNode);

                          case 15:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x9) {
                    return _ref7.apply(this, arguments);
                  };
                }()));

              case 38:
                if (isOwnedByContext(nativeAudioNode, nativeOfflineAudioContext)) {
                  _context4.next = 71;
                  break;
                }

                nativeAudioNode = new nativeAudioWorkletNodeConstructor(nativeOfflineAudioContext, name);
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context4.prev = 43;
                _iterator2 = proxy.parameters.entries()[Symbol.iterator]();

              case 45:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context4.next = 55;
                  break;
                }

                _ref11 = _step2.value;
                _ref10 = _slicedToArray(_ref11, 2);
                nm = _ref10[0];
                audioParam = _ref10[1];
                _context4.next = 52;
                return renderAutomation(proxy.context, nativeOfflineAudioContext, audioParam, // @todo The definition that TypeScript uses of the AudioParamMap is lacking many methods.
                nativeAudioNode.parameters.get(nm));

              case 52:
                _iteratorNormalCompletion2 = true;
                _context4.next = 45;
                break;

              case 55:
                _context4.next = 61;
                break;

              case 57:
                _context4.prev = 57;
                _context4.t1 = _context4["catch"](43);
                _didIteratorError2 = true;
                _iteratorError2 = _context4.t1;

              case 61:
                _context4.prev = 61;
                _context4.prev = 62;

                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                  _iterator2.return();
                }

              case 64:
                _context4.prev = 64;

                if (!_didIteratorError2) {
                  _context4.next = 67;
                  break;
                }

                throw _iteratorError2;

              case 67:
                return _context4.finish(64);

              case 68:
                return _context4.finish(61);

              case 69:
                _context4.next = 100;
                break;

              case 71:
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context4.prev = 74;
                _iterator3 = proxy.parameters.entries()[Symbol.iterator]();

              case 76:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context4.next = 86;
                  break;
                }

                _ref14 = _step3.value;
                _ref13 = _slicedToArray(_ref14, 2);
                _nm = _ref13[0];
                _audioParam = _ref13[1];
                _context4.next = 83;
                return connectAudioParam(proxy.context, nativeOfflineAudioContext, _audioParam, // @todo The definition that TypeScript uses of the AudioParamMap is lacking many methods.
                nativeAudioNode.parameters.get(_nm));

              case 83:
                _iteratorNormalCompletion3 = true;
                _context4.next = 76;
                break;

              case 86:
                _context4.next = 92;
                break;

              case 88:
                _context4.prev = 88;
                _context4.t2 = _context4["catch"](74);
                _didIteratorError3 = true;
                _iteratorError3 = _context4.t2;

              case 92:
                _context4.prev = 92;
                _context4.prev = 93;

                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                  _iterator3.return();
                }

              case 95:
                _context4.prev = 95;

                if (!_didIteratorError3) {
                  _context4.next = 98;
                  break;
                }

                throw _iteratorError3;

              case 98:
                return _context4.finish(95);

              case 99:
                return _context4.finish(92);

              case 100:
                _context4.next = 102;
                return renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAudioNode);

              case 102:
                return _context4.abrupt("return", nativeAudioNode);

              case 103:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[20, 24, 28, 36], [29,, 31, 35], [43, 57, 61, 69], [62,, 64, 68], [74, 88, 92, 100], [93,, 95, 99]]);
      }));

      return function createNativeAudioNode(_x6, _x7) {
        return _ref3.apply(this, arguments);
      };
    }();

    return {
      render: function render(proxy, nativeOfflineAudioContext) {
        if (nativeAudioNodePromise === null) {
          nativeAudioNodePromise = createNativeAudioNode(proxy, nativeOfflineAudioContext);
        }

        return nativeAudioNodePromise;
      }
    };
  };
};